import { AdminScrollPane } from "@/admin/AdminLayout.tsx";
import { createLazyFileRoute, Outlet } from "@tanstack/react-router";

/** The routes under this will display their contents in a single pane */
export const Route = createLazyFileRoute("/admin/_menu/_simple")({
    component: () => (
        <AdminScrollPane>
            <Outlet />
        </AdminScrollPane>
    ),
});
